import React from "react";
import { Nav } from "shards-react";

const NavbarNav = () => <Nav navbar className="border-left flex-row" />;
export default NavbarNav;
